import { Box, Grid } from '@mui/material';
import React from 'react';
import ReactPlayer from 'react-player';

import { useNavigate } from 'react-router-dom';
import Paths from '@/routes/paths';
import useCandidate from '@authentication/hooks/useCandidate';
import {
  BoxContainer,
  BoxContainerCheckDeletePhoto,
  BoxContainerPhoto,
  BoxContainerProgress,
  BoxContainerVideo,
  CardDeletePhoto,
  CardPhoto,
  CardTakePhoto,
  CardTakePhotoTitle,
  CheckCardPhoto,
  GridContainerPhotos,
  IconButtonSound,
  SaveCvButton,
  TitleCover,
  TitleSaveButton,
} from './choose-photos.styled';
import VideoProgressPlayer from '@atoms/VidePlayer';
import useUser from '@authentication/hooks/useUser';
import { ReactComponent as Check } from '../../../../assets/icons/SmallCheck.svg';
import { ReactComponent as Trash } from '../../../../assets/icons/SmallTrash.svg';

import { ReactComponent as SoundOn } from '../../../../assets/icons/SmallSoundOn.svg';
import { ReactComponent as Confirm } from '../../../../assets/icons/FrameStart.svg';
import { ReactComponent as SoundOf } from '../../../../assets/icons/SmallSoundOf.svg';
import { ReactComponent as TakePhotoIcon } from '../../../../assets/icons/SmallPhoto.svg';

import { Photo } from '@authentication/contexts/candidateContext';
import {
  DeleteFinalCvVideo,
  deleteImages,
  uploadCvVidoCandidate,
  uploadImage,
  uploadMergeVideo,
} from '@services/uploadCvVideo';
import { useTimeOut } from '@/hooks/useSetTimeout';
import { BackendUrl } from '@/utils/const';
import { fetchFile } from '@ffmpeg/util';
import useFFmpegStore from '@/store/ffmpg.store';
import useCandidateId from '@/hooks/CandidateIdHook';
import useGeneratedImages from '@/hooks/GeneratedImageHook';
import Loading from '@atoms/Loading';
import useTransCodeHook from '@/hooks/TranscodeHook';
import usePhotoIsTacked from '@/hooks/PhotoTakedHook';
import { useCandidateStore } from '@/store/candidate.store';
import { generateFiveRandomNumbers } from '@/utils';

function ChoosePhotosCard() {
  const { setPageTitle } = useUser();
  const [transcodeDone, handleTranscode, setTranscodeDone] = useTransCodeHook();
  const { setIsSplitPhotos, photos, setPhotos } = useCandidate();
  const [photoTacked] = usePhotoIsTacked();
  const { videoDurationTotal, resetStore } = useCandidateStore();

  const [playedSeconds, setPlayedSeconds] = React.useState(0);
  const [generateImage, setGeneratedImage] = React.useState<any>(false);

  const [isVideoPlaying, setIsVideoPlaying] = React.useState(true);
  const [muted, setMuted] = React.useState(false);
  const [isUploaded, setIsUploaded] = React.useState(false);
  const candidateId = useCandidateId();
  const [fileContent, setFileContent] = React.useState<any>(null);
  const generated = useGeneratedImages();

  const [picked] = React.useState(false);
  const [disableButton, setDisableButton] = React.useState(false);

  const videoDuration = videoDurationTotal.reduce(
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    (acc: any, curr: any) => acc + curr?.duration,
    0,
  );
  const [showPhotos, setShowPhotos] = React.useState(
    localStorage.getItem('showPhotos') === 'true' || false,
  );

  const navigation = useNavigate();
  const handleNavigate = () => {
    if (photos.length <= 5 && !disableButton) {
      navigation(Paths.TakePhoto);
    }
  };

  const handleProgressPlayVideo = (state: any) => {
    setPlayedSeconds(state.playedSeconds);
  };
  const handleVideoClick = () => {
    setIsVideoPlaying((prevState) => !prevState);
  };
  React.useEffect(() => {
    setPageTitle('Choisissez une couverture (optionnelle)');
  }, []);

  const handleMuted = () => {
    setMuted(!muted);
  };

  useTimeOut(() => {
    if (!showPhotos) setShowPhotos(true);
    localStorage.setItem('showPhotos', 'true');
    setIsSplitPhotos(true);
  }, videoDuration * 1000);

  const handleSelectPhoto = async (photoSel: any) => {
    const myPhoto = photos.map((photo: Photo) => {
      if (photoSel.picked === photo?.picked) {
        photo.selected = true;
      }
      if (photo.id === photoSel.id) {
        photo.selected = true;
      } else {
        photo.selected = false;
      }
      return photo;
    });
    setPhotos(myPhoto);
  };

  const handleUploadCvVideo = async () => {
    const grabPhotoSelected = photos.find(
      (photo: Photo) => photo?.selected,
    )?.url;

    try {
      const res: unknown = await uploadCvVidoCandidate(
        grabPhotoSelected,
        candidateId,
      );

      if (res) {
        navigation(Paths.SpacePage);
        localStorage.removeItem('candidate_id');

        setDisableButton(true);
        deleteImages(candidateId);
        DeleteFinalCvVideo(candidateId);
        setPhotos([]);
        setGeneratedImage(false);
        resetStore();
        setTranscodeDone(null);
        localStorage.removeItem('transcodingDone');
        localStorage.removeItem('photoTacked');
      }
    } catch (error) {
      console.log('mee catch last upload', error);
    } finally {
      setDisableButton(false);
    }
  };

  const handleDeletePhotoTakedByUser = async (photoId: string) => {
    const ph = [...photos];
    const res = ph.filter((p: any) => p.id !== photoId);

    setPhotos(res);
  };

  const { ffmpegInstance, isLoaded } = useFFmpegStore();

  const handleGenerateImages = async () => {
    try {
      if (fileContent >= 3 || candidateId) {
        const videoUrl = `${BackendUrl}/uploads/candidate_${candidateId}/final.mp4`;
        const videoBuffer = await fetchFile(videoUrl);

        await ffmpegInstance?.writeFile('final.mp4', videoBuffer);

        const timePoints = generateFiveRandomNumbers(videoDuration);

        for (let i = 0; i < timePoints.length; i++) {
          const time = timePoints[i];

          const outputFileName = `000${i + 1}.png`.slice(-8);

          await ffmpegInstance?.exec([
            '-i',
            'final.mp4',
            '-ss',
            `00:00:${time}`,
            '-frames:v',
            '1',
            outputFileName,
          ]);
        }
        for (let i = 1; i <= 5; i++) {
          const imageName = `${String(i).padStart(4, '00')}.png`;

          const imageBuffer = await ffmpegInstance?.readFile(imageName);
          const myBlob = new Blob([imageBuffer?.buffer], { type: 'image/png' });

          await uploadImage(myBlob, imageName, candidateId);

          if (i === 5) {
            setIsUploaded(true);
            localStorage.setItem('generate_images', 'generated');
          }
        }
      }
    } catch (e) {
      console.log('meee generate img', e);
    }
  };
  async function transcode() {
    if (transcodeDone) {
      return;
    }
    try {
      if (ffmpegInstance !== null && isLoaded) {
        await ffmpegInstance.writeFile(
          '1.mp4',
          await fetchFile(
            `${BackendUrl}/uploads/candidate_${candidateId}/1.mp4`,
          ),
        );
        await ffmpegInstance.writeFile(
          '2.mp4',
          await fetchFile(
            `${BackendUrl}/uploads/candidate_${candidateId}/2.mp4`,
          ),
        );
        await ffmpegInstance.writeFile(
          '3.mp4',
          await fetchFile(
            `${BackendUrl}/uploads/candidate_${candidateId}/3.mp4`,
          ),
        );

        await ffmpegInstance.exec([
          '-i',
          '1.mp4',
          '-i',
          '2.mp4',
          '-i',
          '3.mp4',
          '-filter_complex',
          '[0:v]fps=fps=25,scale=1280:720,format=yuv420p[v0];[1:v]fps=fps=25,scale=1280:720,format=yuv420p[v1];[2:v]fps=fps=25,scale=1280:720,format=yuv420p[v2];[v0][0:a][v1][1:a][v2][2:a]concat=n=3:v=1:a=1[v][a]',
          '-map',
          '[v]',
          '-map',
          '[a]',
          '-c:v',
          'libx264',
          '-preset',
          'ultrafast',
          '-c:a',
          'aac',
          'output.mp4',
        ]);
        const data = await ffmpegInstance.readFile(`output.mp4`);

        const myBlob = new Blob([data.buffer], {
          type: 'video/mp4',
        });

        const res = await uploadMergeVideo(myBlob, candidateId);
        if (res === 200) {
          await handleGenerateImages();
          setIsUploaded(true);
          handleTranscode();
          // localStorage.setItem('transcodingDone', 'true');
        }
      }
    } catch (error) {
      console.log('meee merge vid error', error);
      if (error) return null;
    }
  }
  React.useEffect(() => {
    const test = async () => await handleGenerateImages();
    if (isUploaded) {
      test();
    }
  }, [isUploaded]);

  React.useEffect(() => {
    const transcodeAndGenerate = async () => {
      if (fileContent >= 3) {
        await transcode();
      }
    };

    transcodeAndGenerate();
  }, [fileContent]);

  const fetchFileTxt = async () => {
    if (candidateId)
      try {
        const response = await fetch(
          `${BackendUrl}/uploads/candidate_${candidateId}/step.txt`,
        );
        if (!response.ok) {
          throw new Error('Failed to fetch file');
        }
        const text = await response.text();
        if (text.length > 0) setFileContent(Number(text));
      } catch (error) {
        console.error('Error fetching file:', error);
      }
  };
  const fetchImage = async () => {
    if (candidateId)
      try {
        const response = await fetch(
          `${BackendUrl}/uploads/candidate_${candidateId}/0005.png`,
        );
        if (response.status === 200) {
          setGeneratedImage(true);
        }
      } catch (error) {
        console.error('Error fetching file:', error);
      }
  };
  React.useEffect(() => {
    fetchImage();
  }, [isUploaded]);
  React.useEffect(() => {
    if (candidateId) fetchFileTxt();
  }, [candidateId]);
  React.useEffect(() => {
    if (generateImage) {
      setPhotos([
        {
          selected: true,
          picked: false,
          id: 1,
          url: `${BackendUrl}/uploads/candidate_${candidateId}/0001.png`,
        },
        {
          selected: false,
          picked: false,

          id: 2,
          url: `${BackendUrl}/uploads/candidate_${candidateId}/0002.png`,
        },
        {
          selected: false,
          picked: false,
          id: 3,
          url: `${BackendUrl}/uploads/candidate_${candidateId}/0003.png`,
        },
        {
          selected: false,
          picked: false,
          id: 4,
          url: `${BackendUrl}/uploads/candidate_${candidateId}/0004.png`,
        },
        {
          selected: false,
          picked: false,
          id: 5,
          url: `${BackendUrl}/uploads/candidate_${candidateId}/0005.png`,
        },
      ]);
    }
  }, [generateImage]);
  React.useEffect(() => {
    if (photoTacked && generated) {
      setPhotos((prev: any) => [
        ...prev.map((photo: any) => ({
          ...photo,
          selected: false,
        })),
        {
          selected: true,
          picked: true,
          id: 6,
          url: `${BackendUrl}/uploads/candidate_${candidateId}/photo.png`,
        },
      ]);
      setGeneratedImage(true);
    }
  }, [photoTacked, generateImage]);
  React.useEffect(() => {
    fetchFileTxt();
  }, []);

  if (!transcodeDone) {
    return <Loading />;
  }

  return (
    <BoxContainer>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ paddingTop: 2 }}
      >
        <Grid
          item
          md={12}
          sx={{
            padding: '0',
          }}
        >
          <BoxContainerVideo>
            <IconButtonSound onClick={handleMuted}>
              {muted ? <SoundOf /> : <SoundOn />}
            </IconButtonSound>

            <ReactPlayer
              muted={muted}
              url={`${BackendUrl}/uploads/candidate_${candidateId}/final.mp4`}
              loop
              playing={isVideoPlaying}
              width="100%"
              // height="100%"
              sx={{
                minWidth: '100%',
              }}
              onProgress={(state) => handleProgressPlayVideo(state)}
            />

            <BoxContainerProgress>
              <VideoProgressPlayer
                videoDuration={videoDuration}
                widthProgress="100%"
                onClick={handleVideoClick}
                play={isVideoPlaying}
                playedSeconds={Math.round(playedSeconds)}
              />
            </BoxContainerProgress>
          </BoxContainerVideo>
          <BoxContainerPhoto>
            <TitleCover>
              Choisissez une photo de couverture pour votre CV Vidéo
            </TitleCover>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                background: '#fffbf7',
                flexDirection: 'column',
              }}
            >
              <GridContainerPhotos container>
                {generateImage &&
                  photos?.map((photo: Photo, index: number) => (
                    <Grid
                      key={index}
                      item
                      md={4}
                      sx={{ borderRadius: '20px', padding: '8px' }}
                    >
                      <CardPhoto
                        key={photo.id}
                        onClick={() => handleSelectPhoto(photo)}
                        sx={{
                          border: photo?.selected
                            ? '2px solid #A03A7E'
                            : 'unset',
                        }}
                      >
                        <img
                          src={photo?.url}
                          key={photo?.id}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'fill',
                          }}
                        />
                        {photo?.selected && (
                          <BoxContainerCheckDeletePhoto>
                            <CheckCardPhoto>
                              <Check fontSize="16px" />
                            </CheckCardPhoto>
                            {photo?.selected &&
                              photo?.picked &&
                              !disableButton && (
                                <CardDeletePhoto
                                  onDoubleClick={() =>
                                    handleDeletePhotoTakedByUser(photo.id)
                                  }
                                >
                                  <Trash fontSize="16px" />
                                </CardDeletePhoto>
                              )}
                          </BoxContainerCheckDeletePhoto>
                        )}
                      </CardPhoto>
                    </Grid>
                  ))}
                {photos.length < 6 && (
                  <Grid
                    item
                    md={4}
                    sx={{ borderRadius: '20px', padding: '8px' }}
                  >
                    <CardTakePhoto onClick={handleNavigate}>
                      <TakePhotoIcon />
                      <CardTakePhotoTitle>Prendre une photo</CardTakePhotoTitle>
                    </CardTakePhoto>
                  </Grid>
                )}
              </GridContainerPhotos>
            </Box>
            <SaveCvButton
              disabled={disableButton}
              onClick={handleUploadCvVideo}
              variant="contained"
            >
              <TitleSaveButton>
                Enregister mon CV Vidéo dans Triangle Store RH
              </TitleSaveButton>

              {picked && <Confirm />}
            </SaveCvButton>
          </BoxContainerPhoto>
        </Grid>
      </Grid>
    </BoxContainer>
  );
}

export default ChoosePhotosCard;
